module.exports = __webpack_public_path__ + "img/zahnarztpraxis_6.c3320678.jpg";